export const DOCUMENT_KINDS = [
  'Autres',
  'Annales',
  'Fiches',
  'Polycopiés',
  'Interrogations',
  'Concours blancs',
  'Travaux Dirigés',
  'Plannings',
  'Informations',
];

export const { VUE_APP_API_URL } = process.env;
